import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { getSiteKey } from '../components/RecaptchaProvider/RecaptchaProvider.utils'; // TODO: https://app.shortcut.com/fisherman/story/5606/add-uuid-as-a-dependency-of-fast-components-package

import { randomHex } from './strings';
export var pluralBusinessTypes = ['restaurants', 'merchants'];
export var getServerURL = function getServerURL() {
  // Returns the backend server URL, always with a slash at the end
  var url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL || '';

  if (!url.endsWith('/')) {
    url += '/';
  }

  return url;
};
export function getBusinessTypePath() {
  var businessType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!businessType) {
    return 'restaurants';
  }

  if (pluralBusinessTypes.includes(businessType)) {
    return businessType;
  }

  return "".concat(businessType, "s");
}
export function sendContactFormEmail(_x) {
  return _sendContactFormEmail.apply(this, arguments);
}

function _sendContactFormEmail() {
  _sendContactFormEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var businessType, businessId, locationId, name, email, emailSubject, message, contactOptIn, recaptchaToken, destinationEmail, url, fullUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            businessType = _ref.businessType, businessId = _ref.businessId, locationId = _ref.locationId, name = _ref.name, email = _ref.email, emailSubject = _ref.emailSubject, message = _ref.message, contactOptIn = _ref.contactOptIn, recaptchaToken = _ref.recaptchaToken, destinationEmail = _ref.destinationEmail;
            url = getServerURL();
            fullUrl = "".concat(url, "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/locations/").concat(locationId, "/email/");
            return _context.abrupt("return", axios.post(fullUrl, {
              contact_name: name,
              contact_email: email,
              contact_message: message,
              contact_opt_in: contactOptIn,
              email_subject: emailSubject,
              'recaptcha-token': recaptchaToken,
              'recaptcha-site-key': getSiteKey(),
              destination_email: destinationEmail
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendContactFormEmail.apply(this, arguments);
}

export var searchDomains = function searchDomains(potentialDomain) {
  var headers = {
    'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
  };
  var url = getServerURL();
  return axios.get("".concat(url, "domains/search/details/?domain=").concat(potentialDomain), {
    headers: headers
  });
};
export function searchPlace(_x2) {
  return _searchPlace.apply(this, arguments);
}

function _searchPlace() {
  _searchPlace = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
    var types,
        params,
        headers,
        url,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            types = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'address';
            params = {
              input: value,
              session_token: randomHex(32),
              types: types
            };
            headers = {
              'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
            };
            url = getServerURL();
            return _context2.abrupt("return", axios.get("".concat(url, "businesses/search/autocomplete/"), {
              headers: headers,
              params: params
            }));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _searchPlace.apply(this, arguments);
}

export function placeDetails(_x3) {
  return _placeDetails.apply(this, arguments);
}

function _placeDetails() {
  _placeDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(placeId) {
    var params, headers, url;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            params = {
              place_id: placeId,
              session_token: randomHex(32)
            };
            headers = {
              'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
            };
            url = getServerURL();
            return _context3.abrupt("return", axios.get("".concat(url, "businesses/search/place/details/"), {
              headers: headers,
              params: params
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _placeDetails.apply(this, arguments);
}